import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class SidebarContent extends React.PureComponent {
  render() {
    const { className = '', innerClassName = '', title, actions = null, anchorActionsBottom } = this.props;

    const classes = cx(styles.content, className);
    const innerClasses = cx(styles.inner, innerClassName, {
      [styles.anchorBottom]: anchorActionsBottom,
    });

    return (
      <div className={classes}>
        {title ? (
          <div className={styles.header}>
            <h1>{title}</h1>
          </div>
        ) : null}
        <div className={innerClasses}>
          <div className={styles.children}>{this.props.children}</div>
          <div className={styles.actions}>{actions}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/sidebar-content/index.js